import { register } from "./register";

import { MagicIcon } from "../components/icons";
import { AI_TOOLS_OPEN_EVENT } from "../constants";

export const actionOpenAITools = register({
  name: "aiTools",
  trackEvent: {
    category: "canvas",
    action: "open-tools",
  },
  icon: MagicIcon,
  label: "labels.aiTools",
  keywords: ["ai", "magic", "tools", "generate"],
  viewMode: true,
  perform() {
    if (typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent(AI_TOOLS_OPEN_EVENT));
    }
    return false;
  },
});
